const {Component} = require("react");
const PropTypes = require("prop-types");
const debounce = require("lodash/debounce");
const AlcoholWarning = require('./AlcoholWarning');
const { numberFormat } = require('app/util/formaters');
const Trans = require('app/components/trans/Trans')

class Step extends Component {

	static get propTypes() {
		return {
			active: PropTypes.bool.isRequired,
			blur: PropTypes.bool.isRequired,
			next: PropTypes.func.isRequired,
			prev: PropTypes.func.isRequired,
			close: PropTypes.func.isRequired,
			prevAction: PropTypes.string,
			nextAction: PropTypes.string,
			hasPrevAction: PropTypes.bool,
			hasNextAction: PropTypes.bool,
			index: PropTypes.number.isRequired,
			count: PropTypes.number.isRequired,
			cart: PropTypes.object.isRequired,
			pipelines: PropTypes.object.isRequired,
			showIndex: PropTypes.bool,
			hasPrevStep: PropTypes.bool,
			hasNextStep: PropTypes.bool,
			transitionDuration: PropTypes.number
		};
	}

	static get defaultProps() {
		return {
			prevAction: translate('Tilbage'),
			nextAction: translate('Næste'),
			hasNextAction: true,
			hasPrevAction: true,
			showIndex: true,
			hasPrevStep: true,
			hasNextStep: true,
			transitionDuration: 300
		};
	}

	constructor(props) {
		super(props);

		this.state = {
			active: props.active,
			blur: props.blur,
			transitioning: false,
			submitting: false,
			cart: props.cart
		};
	}

	componentWillReceiveProps(nextProps) {
		let payload = {};

		if (nextProps.active !== this.state.active) {
			payload.active = nextProps.active;
		}

		if (nextProps.blur !== this.state.blur) {
			payload.blur = nextProps.blur;
		}

		if (nextProps.cart !== this.state.cart) {
			payload.cart = nextProps.cart;
		}

		if (Object.keys(payload).length > 0) {
			// Add transitioning
			if (payload.active !== this.state.active) {
				payload.transitioning = true;
			}

			this.setState(payload);

			if (payload.transitioning) {
				setTimeout(() => this.setState({transitioning: false}), this.props.transitionDuration);
			}
		}
	}

	get baseClassName() {
		return "step";
	}

	get className() {
		let classList = [this.baseClassName];

		if (this.state.blur) {
			classList.push("blur");
		}

		if (this.state.active) {
			classList.push("active");
		}

		if (this.state.submitting) {
			classList.push("submitting");
		}

		if (this.state.transitioning) {
			classList.push("transitioning");
		}

		return classList.join(" ");
	}

	get title() {
		return "Step";
	}

	get description() {
		return "";
	}

	get cart() {
		return this.state.cart;
	}

	get pipelines() {
		return this.props.pipelines;
	}

	submit() {
		// return promise
	}

	close() {
		return this.props.close();
	}

	prev() {
		if (this.state.submitting) {
			return;
		}

		this.setState({submitting: true});

		const status = this.return();

		if (status === false) {
			return;
		}

		if (status instanceof Promise) {
			return status
				.then(() => {
					this.setState({submitting: false});
					this.props.prev();
				})
				.catch(() => {
					this.setState({submitting: false});
				});
		}

		this.setState({submitting: false});
		return this.props.prev();
	}

	return() {
		// return promise
	}

    debouncedNext = debounce(() => {
        return this.next();
	}, 5000, {leading: true, trailing: false});

	next() {
		if (this.state.submitting) {
			return;
		}

		this.setState({submitting: true});

		const status = this.submit();

		if (status === false) {
			this.setState({submitting: false});
			return;
		}

		if (status instanceof Promise) {
			return status
				.then(() => {
					this.setState({submitting: false});
					this.props.next();
				})
				.catch(() => {
					this.setState({submitting: false});
				});
		}

		this.setState({submitting: false});
		return this.props.next();
	}

	renderStep() {
		// ...
	}

	renderIndex() {
		if ((this.props.index <= 0) || !this.props.showIndex) {
			return;
		}

		return (
			<div className="step-index">Step {this.props.index}/{this.props.count}</div>
		);
	}

	renderPrevButton() {
		if (!this.props.hasPrevAction) {
			return;
		}

		const arrow = this.props.hasPrevStep ? (<span className="arrow arrow-left"></span>) : null;

		return (
			<button onClick={this.prev.bind(this)} type="button" className="previous-step">
				{arrow}
				{this.props.prevAction}
			</button>
		);
	}

	renderNextButton() {
		if (!this.props.hasNextAction) {
			return;
		}

		const arrow = this.props.hasNextStep ? (<span className="arrow arrow-right"></span>) : null;

		return (
			<button disabled={this.state.submitting} onClick={() => this.next()} type="button" className="next-step">
				{this.props.nextAction}
				{arrow}
			</button>
		);
	}

	renderAdditionalActions() {

	}

	renderOrderFooter() {
		return (
			<div className="order-footer hide-desktop" style={{transform: `translateX(${this.props.index * 100}%)`}}>
				<div className="order-footer__content">
					<div>
						<div className="order-footer__title"><Trans>Varer</Trans> - {numberFormat(this.cart.price.subtotal)}</div>
						<div className="order-footer__subtitle">{this.cart.price.delivery <= 0 ? translate('Afhentning') : translate('Udbringning')} - {numberFormat(this.cart.price.delivery)}</div>
					</div>
					<div className="order-footer__border">
					</div>
					<div className="order-footer__price">
						{numberFormat(this.cart.price.total)}
					</div>
					<div>
						<button onClick={() => this.next()}>
						</button>
					</div>
				</div>
      </div>
		)
	}

	renderBody() {
		return (
			<div className="step-body">
				<div className="step-header">
					{this.renderIndex()}
					<div className="title-line">
						<div className="title">{this.title}</div>
						{this.renderAdditionalActions()}
						<div onClick={this.close.bind(this)} className="close">
							<div className="line-1"></div>
							<div className="line-2"></div>
						</div>
					</div>
					<div className="description">{this.description}</div>
				</div>
				<div className="step-contents">{this.renderStep()}</div>
				<div className="step-footer">
                  <button className="close-button" onClick={this.close.bind(this)}><Trans>Shop videre</Trans></button>
					{this.renderPrevButton()}
					{this.renderNextButton()}
				</div>
				<AlcoholWarning/>
				{this.renderOrderFooter()}
			</div>
		);
	}

	render() {
		return (
			<div ref={el => this.stepElement = el} className={this.className}>{this.renderBody()}</div>
		);
	}

}

module.exports = Step;
